/**
 * This is needed because axios sends the "Accept-Encoding"
 * header which we can't change.
 */
export const removeGzip = (header: string): string =>
  header.replace('--gzip', '');
